import React, { useState, useEffect }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../../tooling/formatTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';

import PolynomialDimensionParamsEditor from './objectInputs/polynomialDimensionParamsEditor';
import TextBox from '../../common/inputs/textBox';
import Select from '../../common/inputs/select';

const FormulaPolynomialEditor = props => {
  const {
    dimensionsList,    
    dimensionInstancesOptions,
    dimensionInstancesFetch,
    dimensionInstancesLoading,
    entity,
    onChange,
    handleGoToEditFormula,
    handleDeleteEntity,
    escBehaviourHandler,
    disabled,    
  } = props;
  let idsArray = [];
  let dimensionParams = entity.childs.map(item => {
    idsArray.push(+item.id);    
    return {
      dimension_id: item.id,
      dimension_name: item.name,
      type: item.type,
      value: item.type==Constants.selectKeys.formulaEditor.polynomialParamTypes.FREE ? 
        "" : (item.content.length>0 ? 
          (item.type==Constants.selectKeys.formulaEditor.polynomialParamTypes.CONTEXT_DIMENSION ? item.content[0].name : (
            item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].period_limit : item.content[0])
          ) : ""),
      period_dimension_ignore_empty: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].ignore_empty : false,
      period_dimension_ignore_actual: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].ignore_actual : false,
      period_dimension_series: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].series : ""
    }
  });
  return (
    <div className="formula_editor_editor_entity_wrapper">
      <div className="formula_editor_editor_entity_label">
        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeName." + entity.type + (entity.is_table ? "T" : "")}) + ": " + entity.name}
        {!disabled && (<span className="simulated-a" onClick={handleDeleteEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.deleteEntity"/></span>)}
      </div>
      <div className="formula_editor_editor_entity_inner">
        <div className="formula_editor_editor_entity_inner_left">
          <PolynomialDimensionParamsEditor
            dimensionList={dimensionsList}
            fullDimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList, "name", "name")}
            dimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(item => !idsArray.includes(+item.id)), "id", "name")}
            typeOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.polynomialParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues")}
            periodTypeExtraOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.periodParamExtraType","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues",false)}
            dimensionInstancesOptions={dimensionInstancesOptions}
            dimensionInstancesFetch={dimensionInstancesFetch}
            dimensionInstancesLoading={dimensionInstancesLoading}
            values={dimensionParams}
            onChange={onChange}
            handleGoToEditFormula={handleGoToEditFormula}
            disabled={disabled}
            escBehaviourHandler={escBehaviourHandler}
          />
        </div>
        <div className="formula_editor_editor_entity_inner_right formula_editor_editor_entity_options">
          <div className="formula_editor_editor_entity_section_label">
            {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.optionsLabel"}) + ":"}                     
          </div>
          <div className="row_fields">
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.TEXT}
              data-path="order"
              data-isoption="true"
              value={entity.options.order}
              dataType={Constants.selectKeys.metric.dataType.NUMBER}
              onChange={onChange}
              labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.optionOrderLabel"/>}
              disabled={disabled}
            />
            <Select 
              data-path="hide"
              data-isoption="true"
              value={"hide" in entity.options ? entity.options.hide : ""}
              onChange={onChange}
              labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.optionHidenLabel"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.optionsBoolean","polynomialAdmin.formulaEditor.entityEditor.optionsBooleanSelectValues")}
              disabled={disabled}
            />
          </div>
          <Select 
            className="formula_editor_editor_entity_stop_option"
            data-path="stop"
            data-isoption="true"
            value={"stop" in entity.options ? entity.options.stop : ""}
            onChange={onChange}
            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.optionStopLabel"/>}
            options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.optionsBoolean","polynomialAdmin.formulaEditor.entityEditor.optionsBooleanSelectValues")}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default FormulaPolynomialEditor;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/formulaPolynomialEditor.jsx